import { useImageMenuContext } from '../ImageMenuContext'
import { SelectedImage } from 'types'

export const useBlazeImageSelection = () => {
  const { selectedImages, toggleSelectedImage } = useImageMenuContext()

  const toggle = (image: SelectedImage) => toggleSelectedImage({ ...image, provider: 'blazeRecommendations' })

  const isSelected = (imageUrl: string) => selectedImages.some((i) => i.url === imageUrl)

  return { toggle, isSelected }
}
